"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var dark_theme_1 = __importDefault(require("../../global/dark-theme"));
var WarningCircleOutline_1 = __importDefault(require("../icons/generated/WarningCircleOutline"));
var InfoCircleOutline_1 = __importDefault(require("../icons/generated/InfoCircleOutline"));
var CheckCircleOutline_1 = __importDefault(require("../icons/generated/CheckCircleOutline"));
var WarningTriangleOutline_1 = __importDefault(require("../icons/generated/WarningTriangleOutline"));
var CloseOutline_1 = __importDefault(require("../icons/generated/CloseOutline"));
var snackbar_style_1 = require("./snackbar.style");
var Snackbar = function (props) {
    var message = props.message, title = props.title, onClose = props.onClose, testID = props.testID, snackbarType = props.snackbarType;
    var _a = react_1.useMemo(function () {
        var backgroundColor;
        var snackbarIcon;
        switch (snackbarType) {
            case 'ALARM':
                backgroundColor = dark_theme_1.default.colours.snackbar.alarmColor;
                snackbarIcon = react_1.default.createElement(WarningCircleOutline_1.default, null);
                break;
            case 'SUCCESS':
                backgroundColor = dark_theme_1.default.colours.snackbar.successColor;
                snackbarIcon = react_1.default.createElement(CheckCircleOutline_1.default, null);
                break;
            case 'WARNING':
                backgroundColor = dark_theme_1.default.colours.snackbar.warningColor;
                snackbarIcon = react_1.default.createElement(WarningTriangleOutline_1.default, null);
                break;
            default:
                backgroundColor = dark_theme_1.default.colours.snackbar.backgroundColor;
                snackbarIcon = react_1.default.createElement(InfoCircleOutline_1.default, null);
        }
        return { backgroundColor: backgroundColor, snackbarIcon: snackbarIcon };
    }, [snackbarType]), backgroundColor = _a.backgroundColor, snackbarIcon = _a.snackbarIcon;
    return (react_1.default.createElement(snackbar_style_1.SnackbarContainer, { "data-test-id": testID },
        react_1.default.createElement(snackbar_style_1.IconContainer, { backgroundColor: backgroundColor }, snackbarIcon),
        react_1.default.createElement(snackbar_style_1.InformationAndActionContainer, null,
            react_1.default.createElement(snackbar_style_1.InformationWrapper, null,
                react_1.default.createElement(snackbar_style_1.SnackbarTitle, null, title),
                react_1.default.createElement(snackbar_style_1.SnackbarMessage, null, message)),
            react_1.default.createElement(snackbar_style_1.CloseIconContainer, { onClick: onClose, "data-test-id": "close-icon" },
                react_1.default.createElement(CloseOutline_1.default, null)))));
};
exports.default = Snackbar;
//# sourceMappingURL=snackbar.component.js.map